const blockedOrUnavailableAvailabilities = new Set<string>([
  "BLOCKED",
  "BLOCKED_BY_BOOKING",
  "BLOCKED_BY_BLOCK",
  "BLOCKED_BY_EVENT",
  "UNAVAILABLE",
]);

export const isAccessibleBookingSlotAvailability = (
  availability: string | null | undefined
): boolean =>
  availability === "ACCESSIBLE_BOOKING" || availability === "ACCESSIBLE";

export const isBlockedOrUnavailableSlotAvailability = (
  availability: string | null | undefined
): boolean => blockedOrUnavailableAvailabilities.has(availability ?? "");

export const isOpenSlotAvailability = (
  availability: string | null | undefined
): boolean => availability === "AVAILABLE" || availability === "FREE";

export const isBlockedByBlockOrEventSlotAvailability = (
  availability: string | null | undefined
): boolean =>
  availability === "BLOCKED_BY_BLOCK" || availability === "BLOCKED_BY_EVENT";

export const isAvailableForBookingDuration = (
  availability: string | null | undefined
): boolean =>
  availability === "AVAILABLE" || availability === "AVAILABLE_AFTER_START";
